import { ThemeProvider } from '@mui/material/styles'
import React, { useMemo } from 'react'

import {
  muiTheme as createTheme,
  themeByDomain
} from '@f-fertighaus/applications/Next/config/styles'

import { Domain } from '../pages/house-detail-page/HDPContent'

interface Props {
  children: React.ReactNode
  domain?: Domain
}

export const MuiThemeProvider = (props: Props) => {
  const muiTheme = useMemo(
    () => createTheme(themeByDomain[props.domain || 'fertighaus']),
    [props.domain]
  )

  return <ThemeProvider theme={muiTheme}>{props.children}</ThemeProvider>
}
